import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import SalesReportsContent from '../SalesReportsContent';
import {
    setFromDate,
    setToDate,
    setSelectedBranch,
    fetchSalesReportData
} from '../../../store/slices/salesReportsSlice';

const SalesReports = () => {
    const dispatch = useDispatch();
    const storedBranchId = localStorage.getItem('branchid') || '';

    useEffect(() => {
        const toDate = new Date();
        const fromDate = new Date();
        fromDate.setDate(fromDate.getDate() - 30);
        dispatch(setFromDate(fromDate));
        dispatch(setToDate(toDate));
        dispatch(setSelectedBranch({ branch_id: storedBranchId || 'All', branch_name: 'Branch' }));
        dispatch(fetchSalesReportData({
            fromDate,
            toDate,
            branchId: storedBranchId || 'All'
        }));
    }, [dispatch, storedBranchId]);

    return <SalesReportsContent />;
};

export default SalesReports;
